import React from "react";

import styles from "./BodyPart.module.scss";

export const BodyPartItem: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.bodyPartItem} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);
